/** Port von `IwmDialogRechnungDokumentUpload.razor` (`@inherits IwmDialogDokumentUpload`). */

import { useCallback } from 'react';

import type { Document } from '@/types/entities';

import { DocumentUploadDialog } from './DocumentUploadDialog';
import { useReceiptMatchcode } from './matchcode';

export interface ReceiptDocumentUploadDialogProps {
  open: boolean;
  onClose: () => void;
  viewId: number;
  receiptId: number;
  onSuccess?: () => void;
}

export function ReceiptDocumentUploadDialog(props: ReceiptDocumentUploadDialogProps) {
  const { receiptId } = props;
  const matchcode = useReceiptMatchcode(props.open, props.viewId, receiptId);

  // Port von `BeforeSave()`.
  const prepareModel = useCallback(
    (model: Document): Document => ({ ...model, ReceiptId: receiptId }),
    [receiptId],
  );

  return (
    <DocumentUploadDialog
      open={props.open}
      onClose={props.onClose}
      onSuccess={props.onSuccess}
      matchcode={matchcode}
      prepareModel={prepareModel}
    />
  );
}

export default ReceiptDocumentUploadDialog;
